import React, { useEffect, useState, useRef, Children, createElement, Component } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { HeroGraphic } from '../components/HeroGraphic';
import { SplitFlapQuote } from '../components/SplitFlapQuote';
import { BookOpenIcon, PlaneIcon, ArrowRightIcon, FlameIcon, HeartIcon, SparklesIcon, InstagramIcon, FacebookIcon, YoutubeIcon, MailIcon } from 'lucide-react';
import { AnimatePresence } from 'framer-motion';
const heroQuotes = [{
  text: "You didn't survive all that shit just to live small. It's time to",
  highlight: 'take up space, babe.'
}, {
  text: "You didn't come this far just to doubt yourself now. You've already survived the hardest parts — it's time to start",
  highlight: 'living like you believe that.'
}, {
  text: "Stop shrinking yourself to make other people comfortable. You weren't made to be easy to handle — you were made to be",
  highlight: 'unforgettable.'
}, {
  text: "You don't need permission to change your life. You just need one moment where you decide you deserve better —",
  highlight: "and don't look back."
}, {
  text: "You are not behind — you're building a vision no one else sees yet. Stay focused.",
  highlight: "They'll understand later."
}];
function RotatingQuoteSection() {
  const [quoteIndex, setQuoteIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setQuoteIndex(prev => (prev + 1) % heroQuotes.length);
    }, 7000);
    return () => clearInterval(interval);
  }, []);
  const current = heroQuotes[quoteIndex];
  return <section className="py-16 bg-gradient-to-br from-plum-900 via-plum-800 to-plum-900 relative overflow-hidden" data-id="element-2789" data-mp="3c5ujip6m04uj">
      <SparkleEffect count={80} data-id="element-2790" data-mp="3h4flou5f8ylm" />
      <div className="absolute top-6 left-6 text-[10rem] font-heading text-white/5 leading-none select-none pointer-events-none" data-id="element-2791" data-mp="3h3nmzagj2kr4">
        "
      </div>
      <div className="absolute bottom-0 right-6 text-[10rem] font-heading text-white/5 leading-none select-none pointer-events-none rotate-180" data-id="element-2792" data-mp="2mhqgbl5kjma7">
        "
      </div>
      <div className="max-w-3xl mx-auto px-4 text-center relative z-10" data-id="element-2793" data-mp="31e7rocdrd0wr">
        <div className="flex items-center justify-center gap-4 mb-6" data-id="element-2794" data-mp="2wh7ny84dsa8t">
          <GlitterHeart size={28} variant="light" className="animate-pulse" data-id="element-2795" data-mp="28psi45debast" />
          <GlitterHeart size={36} variant="light" data-id="element-2796" data-mp="23r8u7zf8roxt" />
          <GlitterHeart size={28} variant="light" className="animate-pulse" data-id="element-2797" data-mp="23sju3o5kgcjn" />
        </div>
        <div className="min-h-[8rem] md:min-h-[10rem] flex items-center justify-center" data-id="element-2798" data-mp="2ih6jkiowqkol">
          <AnimatePresence mode="wait" data-id="element-2799" data-mp="2dp54yq49ohve">
            <motion.blockquote key={quoteIndex} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }} className="text-2xl md:text-3xl lg:text-4xl text-white leading-snug drop-shadow-xl" style={{
            fontFamily: '"Dancing Script", cursive'
          }} data-id="element-2800" data-mp="2dnbu0ymmfbhl">
              "{current.text}{' '}
              <span className="text-cta-400" data-id="element-2801" data-mp="j73nekr3bsoc">{current.highlight}</span>"
            </motion.blockquote>
          </AnimatePresence>
        </div>
        <div className="w-16 h-1 bg-gradient-to-r from-transparent via-cta-400 to-transparent rounded-full mx-auto mt-6" data-id="element-2802" data-mp="a91gxpol87to" />
      </div>
    </section>;
}
function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const formData = new FormData();
      formData.append('fields[email]', email);
      formData.append('fields[name]', name);
      formData.append('ml-submit', '1');
      formData.append('anticsrf', 'true');
      await fetch('https://assets.mailerlite.com/jsonp/2211088/forms/182578891602266068/subscribe', {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
      });
      setStatus('success');
      setEmail('');
      setName('');
    } catch {
      setStatus('error');
    }
  };
  if (status === 'success') {
    return <div className="bg-white/60 rounded-2xl p-6 text-center border border-plum-200/30" data-id="element-2803" data-mp="3k6k2ivf6yqou">
        <p className="font-heading text-xl font-bold text-plum-700 mb-1" data-id="element-2804" data-mp="3k8wlnbwor73h">
          💖 You're in!
        </p>
        <p className="text-plum-500 text-sm font-medium" data-id="element-2805" data-mp="28req2zp9dds1">
          Real talk, course drops, and travel deals coming your way.
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-3" data-id="element-2806" data-mp="ob70u281e10c">
      <div className="flex flex-col sm:flex-row gap-2" data-id="element-2807" data-mp="sa62ndyh1hnk">
        <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" className="flex-1 px-5 py-3.5 rounded-full border border-plum-200/50 bg-white/80 text-plum-700 text-sm font-medium placeholder:text-plum-400 focus:outline-none focus:ring-2 focus:ring-cta-400 focus:border-transparent" data-id="element-2808" data-mp="s8l8hpg2k0q8" />
        <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Name" className="flex-1 px-5 py-3.5 rounded-full border border-plum-200/50 bg-white/80 text-plum-700 text-sm font-medium placeholder:text-plum-400 focus:outline-none focus:ring-2 focus:ring-cta-400 focus:border-transparent" data-id="element-2809" data-mp="1c0rlqqnr38c9" />
      </div>
      <button type="submit" disabled={status === 'loading'} className="w-full px-7 py-3.5 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-md shadow-cta-500/20 whitespace-nowrap disabled:opacity-60" data-id="element-2810" data-mp="3mst6mfyo9qnu">
        {status === 'loading' ? '...' : '💖 Get Notified, Gorgeous'}
      </button>
      {status === 'error' && <p className="text-red-500 text-xs font-medium" data-id="element-2811" data-mp="y07jqlvxlx71">
          Something went wrong. Please try again.
        </p>}
      <p className="text-xs text-plum-500 text-center font-medium leading-relaxed" data-id="element-2812" data-mp="17wiv99np6j0f">
        By subscribing, you agree to our{' '}
        <Link to="/terms" className="underline hover:text-plum-700 transition-colors" data-id="element-2813" data-mp="1lmmdlpjghskl">
          Terms & Conditions
        </Link>{' '}
        and{' '}
        <Link to="/privacy" className="underline hover:text-plum-700 transition-colors" data-id="element-2814" data-mp="1vlbw9kj6fh1w">
          Privacy Policy
        </Link>
        .
      </p>
    </form>;
}
export function HomePage() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  const marqueePhrases = ['No toxic positivity', 'Real talk only', 'The Broken Beginning', 'Healing is messy', 'Take up space, babe'];
  return <div className="min-h-screen overflow-hidden" data-id="element-2815" data-mp="1hk4yogjy60az">
      <style data-id="element-2816" data-mp="1hlg4sn0v7k59">{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
      `}</style>

      {/* SPLIT-FLAP INSPIRATIONAL QUOTES — sits in the navbar gap */}
      <div className="pt-[68px] sm:pt-[76px]" data-id="element-2817" data-mp="1cmwiglid06cd">
        <SplitFlapQuote data-id="element-2818" data-mp="1t0ks4d2j8vqv" />
      </div>

      {/* HERO SECTION - Split Layout */}
      <section className="relative pt-12 pb-20 md:pt-16 md:pb-32 overflow-hidden" data-id="element-2819" data-mp="1o1hngtqgsrjf">
        {/* Dramatic Background Blobs */}
        <div className="absolute inset-0 bg-gradient-to-br from-blush-50 via-white to-lavender-50 -z-20" data-id="element-2820" data-mp="1j13o002xipx0" />
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-blush-300/30 rounded-full blur-[120px] -z-10 -translate-x-1/2 -translate-y-1/4" data-id="element-2821" data-mp="1e28spynrz8w0" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-lavender-300/30 rounded-full blur-[100px] -z-10 translate-x-1/3 translate-y-1/3" data-id="element-2822" data-mp="15aqh811rxh99" />
        <div className="absolute top-1/2 left-1/2 w-[800px] h-[400px] bg-cta-300/10 rounded-full blur-[100px] -z-10 -translate-x-1/2 -translate-y-1/2 rotate-45" data-id="element-2823" data-mp="10c5d3qjeidfj" />

        <SparkleEffect count={150} data-id="element-2824" data-mp="qdzbzb5f5bbq" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2825" data-mp="qcy3nefsf2xp">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center relative" data-id="element-2826" data-mp="mcxcqubi4z9r">
            {/* 100% Real Glassmorphism Card - Floating between text and heart */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            ease: 'easeOut',
            delay: 0.6
          }} className="hidden lg:block absolute left-[46%] top-8 z-30" data-id="element-2827" data-mp="3201jyjks1lmc">
              <motion.div animate={{
              y: [8, -8, 8]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="bg-white/70 backdrop-blur-xl border border-white p-4 rounded-2xl shadow-xl transform rotate-3 inline-flex items-center gap-3" data-id="element-2828" data-mp="2jal48p0itmlc">
                <div className="w-9 h-9 rounded-full bg-cta-100 flex items-center justify-center" data-id="element-2829" data-mp="2bqo4d2z2zi4t">
                  <FlameIcon className="w-4 h-4 text-[#2D1533]" data-id="element-2830" data-mp="2gpqvrkm51pub" />
                </div>
                <div data-id="element-2831" data-mp="2grk557o4yo60">
                  <p className="font-heading text-lg font-bold text-plum-700 leading-tight" data-id="element-2832" data-mp="2lp3lcd4e9b0l">
                    100% Real
                  </p>
                  <p className="text-[10px] font-bold text-plum-500 uppercase tracking-wider" data-id="element-2833" data-mp="2qnetmjf1jdgp">
                    No BS Allowed
                  </p>
                </div>
              </motion.div>
            </motion.div>

            {/* Left Content */}
            <motion.div variants={containerVariants} initial="hidden" animate="visible" className="text-center lg:text-left pt-10" data-id="element-2834" data-mp="22ym1yz5gbrrw">
              <motion.div variants={itemVariants} className="mb-8 inline-block" data-id="element-2835" data-mp="1aa6rmpx9lxmw">
                <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/80 backdrop-blur-md border border-blush-300 text-sm font-bold text-plum-700 shadow-lg shadow-blush-200/50 uppercase tracking-wider transform -rotate-2" data-id="element-2836" data-mp="1f8rrupciohbc">
                  <GlitterHeart size={18} data-id="element-2837" data-mp="3oir4eis9w5vz" />
                  Real talk. Real healing. Real results.
                </span>
              </motion.div>

              <motion.h1 variants={itemVariants} className="text-6xl md:text-8xl font-bold mb-6 tracking-tight leading-[1.1]" style={{
              fontFamily: '"Dancing Script", cursive'
            }} data-id="element-2838" data-mp="3ej8ms8zu4w73">
                <span className="block pb-2 text-plum-700" data-id="element-2839" data-mp="34rchacvf63su">Trippin'</span>
                <span className="block text-[#D63385] text-[56px]" data-id="element-2840" data-mp="30sdbkq1v630c">
                  Through Life
                </span>
                <span className="md:text-6xl block mt-2 text-[#2D1533] text-[80px]" data-id="element-2841" data-mp="2vqo1pdqdnvdu">
                  with Mandy
                </span>
              </motion.h1>

              <motion.p variants={itemVariants} className="text-xl md:text-2xl text-plum-500 max-w-xl mx-auto lg:mx-0 mb-10 font-medium leading-relaxed" data-id="element-2842" data-mp="2lvw264d8iygf">
                I turned my mess into my message—and now I help you through The
                Broken Beginning.
              </motion.p>

              <motion.div variants={itemVariants} className="flex flex-col items-center lg:items-start gap-4" data-id="element-2843" data-mp="238n7h4hyzrqj">
                <span className="inline-flex items-center gap-2 text-sm font-bold text-plum-600 uppercase tracking-widest" data-id="element-2844" data-mp="2uyrpiwi9c2ol">
                  <GlitterHeart size={16} data-id="element-2845" data-mp="2zvrybf6hrjje" />
                  All My Socials
                </span>
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3" data-id="element-2846" data-mp="2m4wljrsvgiaj">
                  <a href="https://www.facebook.com/share/1KSrTKNe17/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center rounded-full bg-cta-500 text-white hover:bg-cta-600 transition-all shadow-lg shadow-cta-500/30 hover:-translate-y-1" aria-label="Facebook" data-id="element-2847" data-mp="2q4ngm7pflkkv">
                    <FacebookIcon className="w-5 h-5" data-id="element-2848" data-mp="1gxvj9gscc4jp" />
                  </a>
                  <a href="https://www.instagram.com/mandy.lee.944023?igsh=eTVlMHFtbXM3M216" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center rounded-full bg-cta-500 text-white hover:bg-cta-600 transition-all shadow-lg shadow-cta-500/30 hover:-translate-y-1" aria-label="Instagram" data-id="element-2849" data-mp="1gzy7pwduhpmb">
                    <InstagramIcon className="w-5 h-5" data-id="element-2850" data-mp="t817z3no6o1k" />
                  </a>
                  <a href="https://www.tiktok.com/@trippin.with.mandy?_r=1&_t=ZP-94syxD66BF1" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center rounded-full bg-cta-500 text-white hover:bg-cta-600 transition-all shadow-lg shadow-cta-500/30 hover:-translate-y-1" aria-label="TikTok" data-id="element-2851" data-mp="29manr9duj4gs">
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-2852" data-mp="n5h8sp18cefj">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-2853" data-mp="x45csjwdqt08" />
                    </svg>
                  </a>
                  <a href="https://youtube.com/@trippinwithmandy?si=y8DXbx-brot4uKGM" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center rounded-full bg-cta-500 text-white hover:bg-cta-600 transition-all shadow-lg shadow-cta-500/30 hover:-translate-y-1" aria-label="YouTube" data-id="element-2854" data-mp="1avtr8tu3ptkd">
                    <YoutubeIcon className="w-5 h-5" data-id="element-2855" data-mp="1l00ahgs1659i" />
                  </a>
                  <a href="mailto:trippinwithmandy@gmail.com" className="w-12 h-12 flex items-center justify-center rounded-full bg-cta-500 text-white hover:bg-cta-600 transition-all shadow-lg shadow-cta-500/30 hover:-translate-y-1" aria-label="Email" data-id="element-2856" data-mp="1l2czgdw7hfw2">
                    <MailIcon className="w-5 h-5" data-id="element-2857" data-mp="23ymdj173y6g2" />
                  </a>
                </div>
              </motion.div>
            </motion.div>

            {/* Right Decorative Composition */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.85
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1.2,
            ease: 'easeOut',
            delay: 0.2
          }} className="relative hidden lg:flex justify-center items-center h-[600px]" data-id="element-2858" data-mp="2wg8j9zy22ctm">
              <HeroGraphic data-id="element-2859" data-mp="fzk99eyi9mbl" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* SASSY MARQUEE */}
      <div className="relative py-6 bg-plum-900 overflow-hidden transform -rotate-1 scale-105 shadow-2xl z-20" data-id="element-2860" data-mp="718agpnhji82">
        <div className="absolute inset-0 bg-gradient-to-r from-cta-500/20 to-plum-500/20 mix-blend-overlay" data-id="element-2861" data-mp="c0kxpbi9qrb6" />
        <div className="flex whitespace-nowrap animate-marquee" data-id="element-2862" data-mp="3t8ycgpozc5cj">
          {/* Double the array for seamless looping */}
          {[...marqueePhrases, ...marqueePhrases, ...marqueePhrases, ...marqueePhrases].map((phrase, i) => <div key={i} className="flex items-center gap-8 mx-8" data-id="element-2863" data-mp="1wg4zchoae3gr" data-mpi={i}>
              <span className="text-2xl md:text-3xl font-bold text-white tracking-wide" style={{
            fontFamily: '"Dancing Script", cursive'
          }} data-id="element-2864" data-mp="3gxxdop9206yx">
                {phrase}
              </span>
              <GlitterHeart size={24} variant="light" data-id="element-2865" data-mp="3qp1qpjf65hr4" />
            </div>)}
        </div>
      </div>

      {/* WHAT I OFFER - Bento Grid */}
      <section className="py-32 bg-blush-50 relative" data-id="element-2866" data-mp="3ihu2tslyvms">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-white rounded-full blur-[100px] -z-10 translate-x-1/2 -translate-y-1/2" data-id="element-2867" data-mp="3l420ujevd5j" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2868" data-mp="dhqkxds6fu4x">
          <div className="text-center mb-20" data-id="element-2869" data-mp="deuojtvz9dil">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="inline-flex items-center justify-center gap-3 mb-6" data-id="element-2870" data-mp="8j5kpecxdagh">
              <GlitterHeart size={24} data-id="element-2871" data-mp="1tf4nrwb3m04m" />
              <h2 className="font-heading text-5xl md:text-6xl font-bold text-plum-700" data-id="element-2872" data-mp="1te3cbqq67bmd">
                How We're Doing This
              </h2>
              <GlitterHeart size={24} data-id="element-2873" data-mp="2357rorjrcyhq" />
            </motion.div>
            <p className="text-plum-500 max-w-2xl mx-auto text-xl font-medium" data-id="element-2874" data-mp="234fwvixzj4si">
              No fluff. No toxic positivity. Just real tools to help you stop
              surviving and start thriving.
            </p>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} className="grid grid-cols-1 lg:grid-cols-3 gap-6 auto-rows-[minmax(250px,auto)]" data-id="element-2875" data-mp="1ffmyzgxsymv9">
            {/* Coaching Card - FEATURED (Spans 2 cols on desktop) */}
            <motion.div variants={itemVariants} className="lg:col-span-2 lg:row-span-2 group relative bg-gradient-to-br from-plum-900 via-plum-800 to-plum-900 p-10 md:p-14 rounded-[3rem] shadow-2xl overflow-hidden flex flex-col justify-between" data-id="element-2876" data-mp="k6jlpvmyg9y3">
              {/* Decorative background elements */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-cta-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-2877" data-mp="5glraxyfmo0g" />
              <div className="absolute bottom-0 left-0 w-80 h-80 bg-lavender-500/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-2878" data-mp="gfznhs5x1id" />
              <SparkleEffect count={40} data-id="element-2879" data-mp="3nmqfnafkisto" />

              <div className="absolute top-8 right-8 opacity-20 group-hover:opacity-40 transition-opacity duration-500 group-hover:scale-110 transform" data-id="element-2880" data-mp="3nniceokwiwlj">
                <GlitterHeart size={120} variant="light" data-id="element-2881" data-mp="1lwezfsnjh5xt" />
              </div>

              <div className="relative z-10 mb-12" data-id="element-2882" data-mp="1gwsknes2bhmw">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm font-bold mb-8 uppercase tracking-wider" data-id="element-2883" data-mp="1gxbtm5zqivos">
                  <FlameIcon className="w-4 h-4 text-cta-400" data-id="element-2884" data-mp="23sadsmdhjbfb" />
                  Signature Experience
                </div>
                <h3 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-2885" data-mp="1yyz2o91n48hl">
                  1:1 Coaching
                </h3>
                <p className="text-white/90 text-xl max-w-md leading-relaxed font-semibold" data-id="element-2886" data-mp="1q1eyar8hdw2r">
                  Personalized, no-BS coaching to help you stop surviving and
                  start thriving. We dig deep and do the real work.
                </p>
              </div>

              <div className="relative z-10 mt-auto" data-id="element-2887" data-mp="1b3mkc3il1fqo">
                <Link to="/coaching" className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-cta-500 text-white font-bold text-lg hover:bg-cta-400 transition-all shadow-lg hover:-translate-y-1 w-full sm:w-auto" data-id="element-2888" data-mp="1b57ie343vgta">
                  <GlitterHeart size={20} variant="light" data-id="element-2889" data-mp="3dxwd6nxz1sqd" />
                  Work With Me
                  <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-2890" data-mp="3hy6p0h8g3dd5" />
                </Link>
              </div>
            </motion.div>

            {/* Courses Card */}
            <motion.div variants={itemVariants} className="group relative bg-gradient-to-br from-white to-blush-50 p-8 md:p-10 rounded-[3rem] shadow-xl border border-blush-200 overflow-hidden flex flex-col justify-between hover:-translate-y-2 transition-transform duration-500" data-id="element-2891" data-mp="3rq2tqb51e1qc">
              <div className="absolute -right-6 -top-6 opacity-10 group-hover:opacity-20 transition-opacity duration-500" data-id="element-2892" data-mp="33z733hcbhcko">
                <BookOpenIcon className="w-40 h-40 text-cta-500" data-id="element-2893" data-mp="390cyjmxd3dxw" />
              </div>

              <div className="relative z-10 mb-8" data-id="element-2894" data-mp="j97wpcax7bk6">
                <div className="w-16 h-16 rounded-2xl bg-blush-200 flex items-center justify-center mb-6 shadow-inner" data-id="element-2895" data-mp="o8kl41hfwqov">
                  <BookOpenIcon className="w-8 h-8 text-plum-700" data-id="element-2896" data-mp="3up9w3ai464zj" />
                </div>
                <h3 className="font-heading text-3xl font-bold text-plum-700 mb-4" data-id="element-2897" data-mp="3prhz422m3soh">
                  The Broken Beginning
                </h3>
                <p className="text-plum-600 font-medium leading-relaxed" data-id="element-2898" data-mp="8i3aunuja07i">
                  The Broken Beginning and beyond. Self-paced courses that don't
                  sugarcoat the journey.
                </p>
              </div>

              <Link to="/courses" className="relative z-10 inline-flex items-center font-bold text-cta-500 hover:text-cta-600 text-lg mt-auto" data-id="element-2899" data-mp="370qq51mje4am">
                <GlitterHeart size={18} className="mr-2" data-id="element-2900" data-mp="3gyof5rc8054a" />
                Get Started
                <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" data-id="element-2901" data-mp="3gwtrw6dh80x1" />
              </Link>
            </motion.div>

            {/* Travel Card */}
            <motion.div variants={itemVariants} className="group relative bg-gradient-to-br from-white to-sky-50 p-8 md:p-10 rounded-[3rem] shadow-xl border border-sky-200 overflow-hidden flex flex-col justify-between hover:-translate-y-2 transition-transform duration-500" data-id="element-2902" data-mp="2o9qxnqfu2ccl">
              <div className="absolute -right-4 -bottom-4 opacity-10 group-hover:opacity-20 transition-opacity duration-500" data-id="element-2903" data-mp="trxwhmxznalh">
                <PlaneIcon className="w-40 h-40 text-sky-500" data-id="element-2904" data-mp="1mhy3psfyozri" />
              </div>

              <div className="relative z-10 mb-8" data-id="element-2905" data-mp="1rhizjtzu4s00">
                <div className="w-16 h-16 rounded-2xl bg-sky-200 flex items-center justify-center mb-6 shadow-inner" data-id="element-2906" data-mp="1rh0x2fmkxhjn">
                  <PlaneIcon className="w-8 h-8 text-plum-700" data-id="element-2907" data-mp="1djuh0st8pwy4" />
                </div>
                <h3 className="font-heading text-3xl font-bold text-plum-700 mb-4" data-id="element-2908" data-mp="1hhs6zxuu4n2k">
                  Travel
                </h3>
                <p className="text-plum-600 font-medium leading-relaxed" data-id="element-2909" data-mp="24z173iuxpfz">
                  Budget-friendly getaways because everyone deserves to escape,
                  reset, and explore.
                </p>
              </div>

              <Link to="/travel" className="relative z-10 inline-flex items-center font-bold text-cta-500 hover:text-cta-600 text-lg mt-auto" data-id="element-2910" data-mp="hkciyez1mxo2">
                <GlitterHeart size={18} className="mr-2" data-id="element-2911" data-mp="7myezeub41cn" />
                Plan a Trip
                <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" data-id="element-2912" data-mp="159yhr1bi7avj" />
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* DRAMATIC QUOTE SECTION - rotating quotes */}
      <RotatingQuoteSection data-id="element-2913" data-mp="vag2gy6jgd9t" />

      {/* NEWSLETTER - MailerLite Embedded Form */}
      <section className="py-32 bg-gradient-to-b from-blush-50 to-white relative overflow-hidden" data-id="element-2914" data-mp="r9nojrmq1k77">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[400px] bg-cta-300/20 rounded-full blur-[120px] -z-10" data-id="element-2915" data-mp="3g31cirrpg9n9" />

        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2916" data-mp="1rivue1br4iay">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#f5d8d8]/80 backdrop-blur-md rounded-2xl p-8 md:p-12 text-center relative shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-white/40" data-id="element-2917" data-mp="1rgstuncz36rz">
            {/* Floating decorative hearts */}
            <div className="absolute -top-6 -left-6 rotate-12" data-id="element-2918" data-mp="2jaut2vga1z7a">
              <GlitterHeart size={60} data-id="element-2919" data-mp="2o8mldqku3nc0" />
            </div>
            <div className="absolute -bottom-8 -right-8 -rotate-12" data-id="element-2920" data-mp="2o83fj88gkpec">
              <GlitterHeart size={80} data-id="element-2921" data-mp="owtzoq3hy4el" />
            </div>

            <div className="relative z-10 max-w-xl mx-auto" data-id="element-2922" data-mp="tuvhl7p6rxoh">
              <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-800 mb-4" data-id="element-2923" data-mp="tvdk2m2fz84u">
                Stay Connected
              </h2>
              <p className="text-plum-700 text-lg mb-8 font-medium leading-relaxed" data-id="element-2924" data-mp="1s6y0bd78cwmx">
                Get real talk, course drops, and travel deals straight to your
                inbox.
              </p>

              {/* MailerLite Newsletter Form */}
              <NewsletterForm data-id="element-2925" data-mp="215t8uvxqyite" />

              <div className="mt-8 pt-6 border-t border-plum-200/30" data-id="element-2926" data-mp="2g4n8sj67961z">
                <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="inline-block text-plum-700 font-medium hover:text-plum-900 transition-colors relative group" data-id="element-2927" data-mp="2g2sn32n3t9wu">
                  Not ready yet? Book a free consultation with me 💖
                  <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-plum-400 scale-x-0 group-hover:scale-x-100 transition-transform origin-left rounded-full" data-id="element-2928" data-mp="2yvmp6vzmp7jn"></span>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}